import { WDD } from '../core/wdd.js';

export function modelSwitch() {
    const product = WDD.el.querySelector('.bp-product');
    const inputs = [...WDD.el.querySelectorAll('[name="bp-product-model"]')];
    const summaryStage = WDD.el.querySelector('[data-summary-stage]');
    const galleryStage = WDD.el.querySelector('[data-gallery-stage]');
    const detail = WDD.el.querySelector('#bp-details-content');

    if (!product || !inputs.length || !summaryStage || !galleryStage || !detail) return;

    const switchingClass = 'bp-product--switching';
    let activeModel = inputs.find(input => input.checked)?.value || inputs[0].value;

    const summaryFor = model => WDD.el.querySelector(`[data-summary-model="${model}"]`);
    const galleryFor = model => WDD.el.querySelector(`[data-gallery-model="${model}"]`);

    const setVisible = (panel, visible) => {
        panel.hidden = !visible;
        panel.setAttribute('aria-hidden', String(!visible));
    };

    function showOnly(selector, attribute, model) {
        WDD.el.querySelectorAll(selector).forEach(panel => setVisible(panel, panel.dataset[attribute] === model));
    }

    function setActiveTab(model) {
        inputs.forEach(input => {
            input.checked = input.value === model;
        });
        WDD.el.querySelectorAll('[data-model-tab]').forEach(label => {
            label.classList.toggle('bp-button--active', label.dataset.modelTab === model);
            label.classList.toggle('bp-button--secondary', label.dataset.modelTab !== model);
        });
    }

    async function switchPanels(stage, oldPanel, newPanel, block) {
        if (!oldPanel || !newPanel || oldPanel === newPanel) return;

        const oldHeight = oldPanel.getBoundingClientRect().height;
        oldPanel.classList.add(`${block}--leaving`);
        await WDD.utils.transitionEnd(oldPanel, 'opacity', 200);
        stage.style.height = `${oldHeight}px`;
        setVisible(newPanel, true);
        newPanel.classList.add(`${block}--entering`);
        setVisible(oldPanel, false);
        oldPanel.classList.remove(`${block}--leaving`);

        const newHeight = newPanel.getBoundingClientRect().height;
        void stage.offsetHeight;
        const heightTransition = WDD.utils.transitionEnd(stage, 'height', 450);
        await WDD.utils.nextFrame();
        stage.style.height = `${newHeight}px`;
        newPanel.classList.remove(`${block}--entering`);
        await heightTransition;
        stage.style.height = '';
    }

    async function activateModel(nextModel) {
        if (product.classList.contains(switchingClass)) {
            setActiveTab(activeModel);
            return;
        }
        if (nextModel === activeModel) return;

        const previousModel = activeModel;
        activeModel = nextModel;
        product.classList.add(switchingClass);
        setActiveTab(nextModel);
        product.dispatchEvent(new CustomEvent('bp:modelchange', { detail: { previousModel, nextModel } }));

        const transitions = [switchPanels(summaryStage, summaryFor(previousModel), summaryFor(nextModel), 'bp-product__summary')];

        if (detail.classList.contains('bp-product__detail--expanded')) {
            transitions.push(switchPanels(galleryStage, galleryFor(previousModel), galleryFor(nextModel), 'bp-feature-gallery'));
        } else {
            showOnly('[data-gallery-model]', 'galleryModel', nextModel);
        }

        try {
            await Promise.all(transitions);
        } catch (error) {
            console.error('Unable to switch the OPPO Find X10 model:', error);
        } finally {
            product.classList.remove(switchingClass);
        }
    }

    inputs.forEach(input => {
        input.addEventListener('change', () => {
            if (input.checked) void activateModel(input.value);
        });
    });

    setActiveTab(activeModel);
    showOnly('[data-summary-model]', 'summaryModel', activeModel);
    showOnly('[data-gallery-model]', 'galleryModel', activeModel);
}
